// extracted by mini-css-extract-plugin
export default {"voteButton":"VoteButton_voteButton__FMsTh","voteContainer":"VoteButton_voteContainer__mYqej"};